import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoBlock } from '../../components/seo_block';
import { useApplicationContext } from '../../utils/applicationContext';
import { EMPTY_SEO_TEXT_KEY, EMPTY_SEO_URLS_KEY, HAS_SEO_TEXT_KEY, HAS_SEO_URLS_KEY } from './constants';
import { NewbuildingSeoBlockContainer } from '../NewbuildingSeoBlock';
import { selectNewbuildingSeoBlock, selectShowNewbuildingSeoBlock } from '../../selectors/newbuildingSeoBlock';
import { selectSeoData } from '../../selectors/seoData';
import { selectSeoUrls } from '../../selectors/seoUrls';
import { SeoUrlsBlock } from '../../components/SeoUrlsBlock';

import * as styles from './SeoContainer.css';

export const SeoContainer = () => {
  const { telemetry } = useApplicationContext();
  const seoData = useSelector(selectSeoData);
  const seoUrls = useSelector(selectSeoUrls);
  const seoBlock = useSelector(selectNewbuildingSeoBlock);
  const showNewbuildingSeoBlock = useSelector(selectShowNewbuildingSeoBlock);

  const { seoText = '', h1 = '' } = seoData;
  const hasSeoText = seoText && h1;
  const hasSeoUrls = seoUrls.length > 0;
  const isEmpty = !hasSeoText && !hasSeoUrls && !seoBlock.region && !seoBlock.city;

  React.useEffect(() => {
    if (hasSeoText) {
      telemetry.increment(HAS_SEO_TEXT_KEY);
    } else {
      telemetry.increment(EMPTY_SEO_TEXT_KEY);
    }

    if (hasSeoUrls) {
      telemetry.increment(HAS_SEO_URLS_KEY);
    } else {
      telemetry.increment(EMPTY_SEO_URLS_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSeoText, hasSeoUrls]);

  if (isEmpty) {
    return null;
  }

  return (
    <div className={styles['c-seo']}>
      <div className="cg-container-fluid-xs">
        <div className="cg-row">
          {hasSeoText && <SeoBlock seoText={seoText} seoTextHeading={h1} />}
          {hasSeoUrls && <SeoUrlsBlock links={seoUrls} />}
        </div>
        {showNewbuildingSeoBlock && <NewbuildingSeoBlockContainer />}
      </div>
    </div>
  );
};
